/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Col, Form, Radio, Row, Select, Space, Spin, Tag, Typography } from "antd";
import CustomModal from "components/CustomModal";
import { SHIPPING_TYPE, USER_PERMISSIONS, USER_STATUS, USER_TYPE } from "config/constants";
import { SHIPPING_PROVIDER_TYPE } from "features/Cart/constants";
import { isShippingTypeDeliver3Party } from "features/Order/helper";
import { useGetShippingProviderServiceFee } from "hooks/cart";
import { useChangeShipper, useUpdateShippingProvider } from "hooks/order";
import useDebounce from "hooks/useDebounce";
import { useGetMe, useGetShipper } from "@monorepo/hooks";
import { DELIVER_ORDER_STATUS } from "pages/App/Order/conts";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { formatCurrency, notify } from "utils/helperFuncs";
import "./index.scss";

export const ButtonChangeShipper = ({ order, handle }) => {
  const [form] = Form.useForm();
  const [searchTerm, setSearchTerm] = useState("");
  const [value, setValue] = useState();
  const [visible, setVisible] = useState(false);
  const { me } = useGetMe();
  const sellerID = me?.seller?.id;
  const [params, setParams] = useState({
    filters: {
      query: undefined,
      permission: USER_PERMISSIONS.ORDER_SHIPPER_DELIVER,
      userType: USER_TYPE.PARTNER_STAFF,
      status: USER_STATUS.ACTIVE,
    },
    pagination: {
      offset: 0,
      limit: 10,
    },
    sort: {
      userType: "ASC",
      by: "TOTAL_DELIVERY",
    },
  });

  const serviceFeeInput = {
    orderID: order?.id,
    carrierMethods: order?.shippingConfiguration?.deliver3PartyConfig?.carrierMethod,
  };

  const { data: dataShippingProvider } = useGetShippingProviderServiceFee({
    shippingType: order?.shippingType,
    serviceFeeInput: serviceFeeInput,
  });
  const { shippers, loading: loadingGetShipper } = useGetShipper({
    ...params,
    filters: { ...params.filters, sellerID },
    skip: !sellerID,
  });

  const renderTag = (inDeliverOrders) => {
    if (!inDeliverOrders?.length) {
      return (
        <Row>
          <Tag color="green">{t("order.orderList.orderNotAssigned")}</Tag>
        </Row>
      );
    }
    return (
      <Row>
        {inDeliverOrders.map(({ status, count }) =>
          status === DELIVER_ORDER_STATUS.WAIT_TO_DELIVER ? (
            <Tag key={status} color="orange">
              {t("order.orderList.orderWaitAssigned")} {count}
            </Tag>
          ) : (
            <Tag key={status} color="red">
              {t("order.orderList.orderAssigned")} {count}
            </Tag>
          )
        )}
      </Row>
    );
  };
  const debounceValue = useDebounce(searchTerm);

  const { handleUpdateShippingProvider, loading: loadingChangShipper1 } = useUpdateShippingProvider();

  const { handleChangeShipper, loading: loadingChangShipper2 } = useChangeShipper();

  const addProduct = async () => {
    try {
      const values = await form.validateFields();
      const params = {
        orderID: order.id,
        newShipperID: values?.shipperID,
        newShippingProviderID: values?.providerID && values?.providerID?.split(" ")[0],
      };
      if (isShippingTypeDeliver3Party(order.shippingType)) {
        await handleUpdateShippingProvider(params)
          .then(() => {
            notify.success({
              message: t("common.changeShipperSuccess"),
            });
            setVisible(false);
            form.resetFields();
          })
          .catch((error) => {
            notify.error({
              message: t("order.selectingShipper.confirmDeliverError"),
              description: error.message,
            });
          });
      }
      if (order.shippingType === SHIPPING_TYPE.BUS) {
        await handleChangeShipper({ orderIDs: order.id, shipperID: values?.shipperID })
          .then(() => {
            notify.success({
              message: t("common.changeShipperSuccess"),
            });
            setVisible(false);
            form.resetFields();
          })
          .catch((error) => {
            notify.error({
              message: t("order.selectingShipper.confirmDeliverError"),
              description: error.message,
            });
          });
      }
    } catch (error) {
      notify.error({
        message: error,
        description: error.message,
      });
    }
  };
  const onSelectedMethod = (e) => {
    setValue(e?.target?.value);
  };

  useEffect(() => {
    setParams({
      ...params,
      filters: {
        ...params.filters,
        query: debounceValue,
      },
      pagination: {
        limit: 10,
        offset: 0,
      },
    });
  }, [debounceValue]);
  return (
    <CustomModal
      title={
        <Typography.Text strong style={{ fontSize: "18px" }}>
          {order && isShippingTypeDeliver3Party(order?.shippingType)
            ? t("order.delivery.ListAvailableAarriers")
            : t("order.selectingShipper.title2")}
        </Typography.Text>
      }
      width="45%"
      footer={false}
      centered={true}
      htmlType="submit"
      customComponent={
        <Button style={{ width: "100%" }} type="primary" onClick={() => setVisible(true)}>
          {t("common.changeShipper")}
        </Button>
      }
      buttonLoading={loadingChangShipper1 || loadingChangShipper2}
      onOke={() => addProduct()}
      onCancel={() => setVisible(false)}
      visible={visible}
    >
      <Form form={form}>
        <div className="form-button-division-order">
          <Col span={24}>
            {isShippingTypeDeliver3Party(order?.shippingType) && (
              <Row gutter={[8]}>
                <Typography.Text className="text-title-method">{t("order.delivery.DeliveryMethod")}:</Typography.Text>
                <Typography.Text className="text-highline">
                  {SHIPPING_PROVIDER_TYPE[dataShippingProvider && dataShippingProvider[0]?.method]}
                </Typography.Text>
              </Row>
            )}
          </Col>
          <Col span={24} className="form-content">
            {order.shippingType === SHIPPING_TYPE.BUS && (
              <Space direction="vertical" style={{ width: "100%" }}>
                <div className="form-select-pick-shipper">
                  <Form.Item
                    name="shipperID"
                    label={<Typography.Text strong>Shipper</Typography.Text>}
                    rules={[
                      {
                        required: true,
                        message: t("order.selectingShipper.shipperValidateMessage"),
                      },
                    ]}
                  >
                    <Select
                      size="middle"
                      showSearch
                      placeholder={t("order.selectingShipper.shipperPlaceholder")}
                      filterOption={false}
                      optionLabelProp="label"
                      onSearch={(value) => setSearchTerm(value)}
                      dropdownRender={(originNode) => <Spin spinning={loadingGetShipper}>{originNode}</Spin>}
                    >
                      {shippers?.map(({ value: shipperValue, label, inDeliverOrders }) => (
                        <Select.Option
                          key={shipperValue}
                          value={shipperValue}
                          label={
                            <Space style={{ display: "flex", justifyContent: "space-between" }}>
                              <Typography.Text>{label}</Typography.Text>
                              {renderTag(inDeliverOrders)}
                            </Space>
                          }
                        >
                          <Space style={{ display: "flex", justifyContent: "space-between" }}>
                            <Typography.Text>{label}</Typography.Text>
                            {renderTag(inDeliverOrders)}
                          </Space>
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </Space>
            )}
            {isShippingTypeDeliver3Party(order?.shippingType) && (
              <Form.Item
                layout="vertical"
                className="form-radio"
                name="providerID"
                rules={[
                  {
                    required: true,
                    message: <div style={{ marginLeft: "20px" }}>{t("order.delivery.ChooseDeliveryMethod")}</div>,
                  },
                ]}
              >
                {visible && (
                  <Radio.Group value={value} onChange={(e) => onSelectedMethod(e)}>
                    <Space direction="vertical" style={{ width: "100%" }}>
                      {dataShippingProvider &&
                        dataShippingProvider[0]?.providers?.map((item) => (
                          <>
                            <Radio value={item.id}>
                              <Row className="method-item">
                                <div className="text-name-method">{item?.name}</div>
                                <div className="text-money">{formatCurrency(item?.fee)}</div>
                              </Row>
                            </Radio>

                            {item?.code === "HA_EXPRESS" && item.id === value && (
                              <div className="form-select-pick-shipper">
                                <Form.Item
                                  name="shipperID"
                                  rules={[
                                    {
                                      required: true,
                                      message: t("order.selectingShipper.shipperValidateMessage"),
                                    },
                                  ]}
                                >
                                  <Select
                                    size="middle"
                                    showSearch
                                    placeholder={t("order.selectingShipper.shipperPlaceholder")}
                                    filterOption={false}
                                    optionLabelProp="label"
                                    onSearch={(value) => setSearchTerm(value)}
                                    dropdownRender={(originNode) => (
                                      <Spin spinning={loadingGetShipper}>{originNode}</Spin>
                                    )}
                                  >
                                    {shippers?.map(({ value: shipperValue, label, inDeliverOrders }) => (
                                      <Select.Option
                                        key={shipperValue}
                                        value={shipperValue}
                                        label={
                                          <Space style={{ display: "flex", justifyContent: "space-between" }}>
                                            <Typography.Text>{label}</Typography.Text>
                                            {renderTag(inDeliverOrders)}
                                          </Space>
                                        }
                                      >
                                        <Space style={{ display: "flex", justifyContent: "space-between" }}>
                                          <Typography.Text>{label}</Typography.Text>
                                          {renderTag(inDeliverOrders)}
                                        </Space>
                                      </Select.Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </div>
                            )}
                          </>
                        ))}
                    </Space>
                  </Radio.Group>
                )}
              </Form.Item>
            )}
          </Col>
        </div>
      </Form>
    </CustomModal>
  );
};
